export default __webpack_public_path__ + "static/default-banner-008ac715a19a7cae5747f617f7db7986.png";